// src/pages/AdminApproval.js
import { Box, CircularProgress } from "@mui/material";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import { useTheme } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import warning from "../../../assets/warning.svg";
import { useTranslation } from "react-i18next";

const AdminApproval = () => {
  const theme = useTheme();
  const location = useLocation();
  const { message } = location.state || {}; 
    const { t } = useTranslation();

  console.log(message)
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#EFF4F8",
        px: 2,
      }}
    >
      {/* Container box like modal card */}
      <Box
        sx={{
          maxWidth: 420,
          width: "100%",
          bgcolor: "white",
          borderRadius: "13px",
          boxShadow: 0,
          p: 3,
          textAlign: "center",
        }}
      >
        <img src={warning} style={{width:90,height:90}}/>
        {/* Title */}
        <CustomText
          sx={{
            ...textStyles,
            fontSize: "24px",
            fontWeight:500,
              fontFamily: 'Poppins, sans-serif',
            color: theme.palette.tertiary.main,
            mb: 2,
            mt:1, 
            letterSpacing: "0px !important",
          }}
        >
                    {t("adminApproval.title")}

        </CustomText>

        {/* Message */}
        <CustomText
          sx={{
            ...textStyles.body4,
            color: theme.palette.text.primary,
            mb: 3,
          }}
        >
        { t("adminApproval.defaultMessage")}
        </CustomText>

  
      </Box>
    </Box>
  );
};

export default AdminApproval;
